var map = {
	"./Join.svg": 1027,
	"./Logo.svg": 1028,
	"./LogoWhite.svg": 417,
	"./Oops.png": 183,
	"./about.png": 1029,
	"./accelerate.svg": 1030,
	"./account-detail.svg": 1031,
	"./account-info.svg": 1032,
	"./back.svg": 1033,
	"./ball.png": 1034,
	"./bg-ball1.png": 1035,
	"./bg-ball2.png": 1036,
	"./blockchain.svg": 1037,
	"./box1.jpg": 1038,
	"./box2.jpg": 1039,
	"./box3.jpg": 1040,
	"./box4.jpg": 1041,
	"./bsc-logo.svg": 1042,
	"./business.svg": 1043,
	"./change.svg": 1044,
	"./circle1.png": 1045,
	"./circle2.png": 1046,
	"./circle3.png": 1047,
	"./circle4.png": 1048,
	"./close.svg": 1049,
	"./copy.svg": 1050,
	"./copyIcon.svg": 1051,
	"./dashboard.svg": 1052,
	"./delete.svg": 1053,
	"./discord.svg": 1054,
	"./discord_logo.svg": 418,
	"./doc.svg": 1055,
	"./download.svg": 1056,
	"./downup.png": 415,
	"./edit.svg": 1057,
	"./edit2.svg": 1058,
	"./ethereum-logo.png": 217,
	"./externalLink.svg": 1059,
	"./facebook.svg": 1060,
	"./fil.png": 182,
	"./file-type.svg": 1061,
	"./file.svg": 1062,
	"./footerSao.png": 1063,
	"./github.svg": 1064,
	"./group1.png": 401,
	"./group2.png": 402,
	"./group3.png": 403,
	"./group4.png": 404,
	"./groupBg.png": 407,
	"./groupline1.png": 405,
	"./groupline2.png": 406,
	"./hammer.png": 1065,
	"./homebg.jpg": 1066,
	"./hometop.png": 1067,
	"./icon1.svg": 1068,
	"./icon2.svg": 1069,
	"./icon3.svg": 1070,
	"./icon4.svg": 1071,
	"./image1.png": 1072,
	"./image2.png": 1073,
	"./image3.png": 1074,
	"./image4.png": 1075,
	"./image5.png": 1076,
	"./instergram.svg": 1077,
	"./ipfs.png": 1078,
	"./jpg.svg": 1079,
	"./learnmore.svg": 1080,
	"./link.svg": 1081,
	"./list_type.svg": 1082,
	"./luanchBtn.png": 1083,
	"./maintenance.svg": 1084,
	"./medium.svg": 1085,
	"./metamask-fox.svg": 416,
	"./mining-expiration.svg": 1086,
	"./mining-pool.png": 1087,
	"./miningdata.svg": 1088,
	"./mint.png": 1089,
	"./module_type.svg": 1090,
	"./moredetaislbtn.png": 1091,
	"./mp4.svg": 1092,
	"./new.png": 1093,
	"./new.svg": 1094,
	"./nft-alpha.jpg": 1095,
	"./nft-bg.jpg": 1096,
	"./nft-dashboard.svg": 1097,
	"./nft-failed.svg": 1098,
	"./nft-legend.jpg": 1099,
	"./nft-super.jpg": 1100,
	"./nft-ultra.jpg": 1101,
	"./nft.svg": 1102,
	"./nodata.svg": 1103,
	"./opensea.png": 419,
	"./opensea.svg": 1104,
	"./pdf.svg": 1105,
	"./personal.svg": 1106,
	"./phoneBack.png": 1107,
	"./png.svg": 1108,
	"./pool-active.png": 184,
	"./pool-closed.png": 259,
	"./product.svg": 1109,
	"./returnArrow_icon.svg": 1110,
	"./roadmapbg.png": 413,
	"./sao_logo.svg": 1111,
	"./searchImg.png": 1112,
	"./spin.svg": 1113,
	"./start-mining.svg": 1114,
	"./step1.png": 1115,
	"./step2.png": 1116,
	"./step3.png": 1117,
	"./stone1.png": 1118,
	"./stone2.png": 1119,
	"./stone3.png": 1120,
	"./storagebg.png": 1121,
	"./storagemask.png": 1122,
	"./subscribe-closed.svg": 1123,
	"./subscribe.svg": 1124,
	"./table.svg": 1125,
	"./test_img1.png": 1126,
	"./test_img2.png": 264,
	"./threebtm.png": 409,
	"./threeicon1.png": 410,
	"./threeicon2.png": 411,
	"./threeicon3.png": 412,
	"./threetop.png": 408,
	"./tipsets.svg": 1127,
	"./twitter.svg": 1128,
	"./updown.png": 414,
	"./use.svg": 1129,
	"./wallet.svg": 1130,
	"./walletConnectIcon.svg": 1131,
	"./warning.svg": 1132,
	"./wave.png": 1133,
	"./x.svg": 1134,
	"./zip.svg": 1135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 394;